export default {
  en: {
    title: "Forgot Password",
    subtitle: "Enter your email to receive a verification code",
    email_label: "Email",
    email_placeholder: "Enter your email",
    request_otp: "Request OTP",
    verify_otp_title: "Verify OTP",
    verify_otp_subtitle: "Enter the 6-digit code sent to {email}",
    otp_label: "Verification Code",
    otp_placeholder: "Enter 6-digit code",
    verify_otp: "Verify OTP",
    resend_otp: "Resend OTP",
    change_email: "Change Email",
    reset_password_title: "Reset Password",
    reset_password_subtitle: "Enter your new password",
    new_password_label: "New Password",
    new_password_placeholder: "Enter new password",
    confirm_password_label: "Confirm Password",
    confirm_password_placeholder: "Confirm new password",
    reset_password: "Reset Password",
    success_title: "Password Reset Successful!",
    success_message:
      "Your password has been reset successfully. You can now log in with your new password.",
    back_to_login: "Back to Login",
    footer_text: "Need help? Contact your system administrator",
  },
  ar: {
    title: "نسيت كلمة المرور",
    subtitle: "أدخل البريد الإلكتروني لاستلام رمز التحقق",
    email_label: "البريد الإلكتروني",
    email_placeholder: "أدخل البريد الإلكتروني",
    request_otp: "طلب رمز التحقق",
    verify_otp_title: "التحقق من الرمز",
    verify_otp_subtitle: "أدخل الرمز المكون من 6 أرقام المرسل إلى {email}",
    otp_label: "رمز التحقق",
    otp_placeholder: "أدخل الرمز المكون من 6 أرقام",
    verify_otp: "التحقق من الرمز",
    resend_otp: "إعادة إرسال الرمز",
    change_email: "تغيير البريد الإلكتروني",
    reset_password_title: "إعادة تعيين كلمة المرور",
    reset_password_subtitle: "أدخل كلمة المرور الجديدة",
    new_password_label: "كلمة المرور الجديدة",
    new_password_placeholder: "أدخل كلمة المرور الجديدة",
    confirm_password_label: "تأكيد كلمة المرور",
    confirm_password_placeholder: "أكد كلمة المرور الجديدة",
    reset_password: "إعادة تعيين كلمة المرور",
    success_title: "تم إعادة تعيين كلمة المرور بنجاح!",
    success_message:
      "تم إعادة تعيين كلمة المرور بنجاح. يمكنك الآن تسجيل الدخول بكلمة المرور الجديدة.",
    back_to_login: "العودة لتسجيل الدخول",
    footer_text: "تحتاج مساعدة؟ اتصل بمدير النظام",
  },
};
